import React, { useState } from "react";
import { Form, InputNumber, Modal, Select } from "antd";

const SimulazionePercentageEditModal = ({ isVisible, onOk, onCancel }) => {
  const [bulkEditField, setBulkEditField] = useState('');
  const [bulkEditValue, setBulkEditValue] = useState(0);

  const resetForm = () => {
    setBulkEditField('');
    setBulkEditValue(0);
  };

  const handleOk = () => {
    onOk(bulkEditField, bulkEditValue);
    resetForm();
  };

  const handleCancel = () => {
    resetForm();
    onCancel();
  };

  return (
    <Modal
      visible={isVisible}
      title="Modifica percentuale"
      onOk={handleOk}
      onCancel={handleCancel}
      okText="Conferma"
      cancelText="Annulla"
      okButtonProps={{
        disabled: !bulkEditField || !bulkEditValue
      }}
    >
      <Form.Item label="Campo da modificare">
        <Select
          style={{ width: '100%' }}
          value={bulkEditField}
          placeholder="Seleziona il campo"
          onChange={setBulkEditField}
        >
          <Select.Option value="prxVtecnsDossier">PV Futuro</Select.Option>
          <Select.Option value="qteVteDossier">QTA Futura</Select.Option>
        </Select>
      </Form.Item>
      <Form.Item label="Variazione percentuale">
        <InputNumber
          min={-100}
          max={100}
          value={bulkEditValue}
          onChange={setBulkEditValue}
        />
      </Form.Item>
    </Modal>
  )
};

export default SimulazionePercentageEditModal;